<div class="container-fluid logo">
  <img src="assets/images/logo.svg" alt="Logo">
</div>